import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7.5,
		cy: 7.5,
		r: 5.5,
		stroke: "currentColor",
		strokeWidth: 1.2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.5 11.5L14 14",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "square"
	})]
});
export default SvgSearch;
